import API from './axios.js';

export const registerUser = (userData) => API.post('auth/register', userData);
export const loginUser = (credentials) => API.post('auth/login', credentials);

export const getUserData = (id) => API.get(`auth/user-id`, { params: { id } });

export const getUserDataByID = (id) => API.get(`/auth/user-id?id=${id}`);

export const getCaseAssignmentToUserByUserID = (userID) => API.get(`case-assignment/${userID}`);
export const getCaseAssignmentToUserByCourtRef = (courtRef) => API.get(`case-assignment/court-ref/${courtRef}`);

export const addCaseAssignmentToUser = (payload) => API.post(`case-assignment`,payload);
export const deleteCaseAssignmentToUser = (id) => API.delete(`case-assignment/${id}`);

export const sendemailotp = (email) => API.post(`auth/send-email-otp`, email );
export const verifyemailotp = (email,otp) => API.post(`auth/verify-email-otp`, email , otp );

export const sendsmsotp = (phone) => API.post(`auth/send-sms-otp`, phone );
export const sendwhatsappsmsotp = (phone) => API.post(`auth/send-whatsapp-otp`, phone );

export const verifysmsotp = (phone,otp) => API.post(`auth/verify-sms-otp`, phone , otp );
export const verifywhatsappsmsotp = (phone,otp) => API.post(`auth/verify-whatsapp-otp`, phone ,otp );

export const getUserProfileData = () => API.get(`auth/me`);
export const updateUserProfile = (id,payload) => API.patch(`auth/${id}`,payload);
export const updateCompanyProfile = (id,payload) => API.patch(`company/${id}`,payload);


export const createLoginLog = (logData) => API.post('login-logs', logData);

export const getPlanData = (planId) => API.get(`/plans/${planId}`);
export const getStorageSize = (companyId) => API.get(`/ftp/storage-size/${companyId}`);
export const getCustomerPendingDocData = () => API.get(`/document/by-client`);